import { GREY_100, GREY_600 } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';

const UploadWrapper = styled.div<{ $portrait?: boolean }>`
  position: relative;
  width: 100%;
  background-color: ${GREY_100};
  border: 1px dashed ${GREY_600};
  border-radius: 0.25rem;
  min-height: ${({ $portrait }) => ($portrait ? '7.5rem' : '12.5rem')};
`;

export default UploadWrapper;
